import { PlusOutlined } from '@ant-design/icons';

export const UploadButton = (
  <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
);
